import { Constants } from '../constants';
import { labelsMiddlewareModeled } from '../mocks/labels-middleware-modeled';
import { LabelsModeled } from '../types/LabelsModeled';
import { PrivacyShieldLabels } from '../types/PrivacyShieldLabels';
import { getLabelsByLanguage } from './getLabelsByLanguage';

export const getLabelsToPlaceholder = (
  language: string,
  technologyName: string,
  labels: LabelsModeled[],
): PrivacyShieldLabels => {
  const name = technologyName?.toLowerCase().replace(/\s|_/g, '');
  const labelsCurrentLanguage = getLabelsByLanguage(language, labels);
  const labelsDefaultLanguage = getLabelsByLanguage(Constants.DEFAULT_LANGUAGE_CODE, labelsMiddlewareModeled);
  const defaultLabels = labelsDefaultLanguage?.[Constants.DEFAULT_LANGUAGE_CODE];
  const currentLabels = labelsCurrentLanguage?.[language];

  const headlineText: string = currentLabels?.[`${name}_headline`] || defaultLabels?.[`${name}_headline`];
  const descriptionText: string = currentLabels?.[`${name}_description`] || defaultLabels?.[`${name}_description`];
  const primaryButtonText: string =
    currentLabels?.[`${name}_primaryButton`] || defaultLabels?.[`${name}_primaryButton`];
  const secondaryButtonText: string =
    currentLabels?.[`${name}_secondaryButton`] || defaultLabels?.[`${name}_secondaryButton`];

  return {
    headlineText,
    descriptionText,
    primaryButtonText,
    secondaryButtonText,
  };
};
